<template>
  <div class="content-view" :style="styleView">
    <div v-if="title" class="cv-title">{{title}}</div>
    <div class="cv-content custom-scrollbar" :class="[border ? '' : 'bd-0', ...flexClass]">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'content-view',
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '30%'
    },
    height: {
      type: String,
      default: '100%'
    },
    border: {
      type: Boolean,
      default: true
    },
    flex: {
      type: String,
      default: ''
    }
  },
  computed: {
    styleView() {
      return {
        width: this.width,
        height: this.height
      }
    },
    flexClass() {
      const res = []
      if (this.flex) {
        res.push('flex')
        res.push(this.flex)
      }
      return res
    }
  },
}
</script>
<style scoped>
.content-view {
  box-sizing: border-box;
}
.cv-title {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold', 'PingFang SC', sans-serif;
  color: #fff;
  font-size: 18px;
  background-color: rgba(46, 44, 138, 1);
  border: 1px solid rgba(45, 140, 240, 1);
  border-radius: 6px 6px 0 0 ;
}
.cv-content {
  box-sizing: border-box;
  width: 100%;
  height: calc(100% - 40px);
  border: 1px solid rgba(45, 140, 240, 1);
  border-top: none;
  border-radius: 0 0 6px 6px;
  overflow: auto;
}
.bd-0{
  border: none;
}
.flex {
  display: flex;
  align-items: center;
}
.flex-start {
  justify-content: flex-start;
}
.flex-end {
  justify-content: flex-end;
}
.space-around {
  justify-content: space-around;
}
.space-between {
  justify-content: space-between;
}
</style>
